import React, { useState, useEffect } from "react";
import { HyperLink } from "../simple-buttons/simple-buttons";
import { StyledBoiTooltip, StyledTooltip } from "./boi-tooltip.styles";
import BoiReactMarkdown from "../boi-markdown/boi-markdown";

export const BoiTooltip = ({ id, customTooltip }) => {
    const [tooltipOpen, setTooltipIsOpen] = useState(false);
    const handleClick = e => {
        const openTip = document.querySelector(".tooltip-inner");
        if (openTip && !openTip.contains(e.target)) {
            if (tooltipOpen) setTooltipIsOpen(false);
        }
    };
    useEffect(() => {
        document.addEventListener("click", handleClick);

        return () => {
            document.removeEventListener("click", handleClick);
        };
    });
    return (
        <StyledBoiTooltip id={`${id}_tooltip`}>
            &nbsp;
            <HyperLink
                id={id}
                className="tooltip-icon"
                aria-label={customTooltip}
            />
            <StyledTooltip
                placement="top"
                isOpen={tooltipOpen}
                toggle={() => {
                    setTooltipIsOpen(!tooltipOpen);
                }}
                trigger="click"
                className="boi-tip"
                flip={false}
                delay={{ show: 0, hide: 0 }}
                // container={`${id}_tooltip`}
                target={id}>
                <BoiReactMarkdown
                    disallowedElements={["p"]}
                    unwrapDisallowed={true}
                >
                    {customTooltip}
                </BoiReactMarkdown>
            </StyledTooltip>
        </StyledBoiTooltip>
    );
};
